import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  isOpen: false,
  title: '',
  description: '',
  success: false,
  updateNotificationCount: false,
  isUnread: false,
  tabName: 'unread',
};

const notifications = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    openNotification: (state, action) => {
      state.isOpen = true;
      state.title = action.payload.title;
      state.description = action.payload.description;
      state.success = action.payload.success;
    },
    closeNotification: state => {
      state.isOpen = false;
      state.title = '';
      state.description = '';
      state.success = false;
    },
    setIsUnread: (state, action) => {
      state.isUnread = action.payload;
    },
    setNotificationcount: (state, action) => {
      state.updateNotificationCount = action.payload;
    },
    setTabName: (state, action) => {
      state.tabName = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  openNotification,
  closeNotification,
  setNotificationcount,
  setTabName,
  setIsUnread,
} = notifications.actions;

export default notifications.reducer;
